import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {ResponseContainerState} from '../state';
import {Layout, Panel, Display} from 'shared/components';
import {QuestionFieldFactory} from 'main/components/forms/question/components';
import {redirect} from 'shared/tools';

const ResponseForm = observer(({uiState}) => {
  const {response} = uiState;

  return (
    <Panel.Stack>
      {response.sortedAnswers.map((answer) =>
        <Panel key={answer.id}>
          <QuestionFieldFactory
            answer={answer}
            disabled
          />
        </Panel>)
      }
    </Panel.Stack>
  );
});

const ResponseContainer = observer(({uiState}) => {
  const {response, backPath} = uiState;

  return (
    <React.Fragment>
      <Display
        title={`${response.survey.name}: ${response.employee.name}`}
        onBackClick={() => redirect(backPath)}
      />
      <Layout>
        <Layout.Section>
          <ResponseForm uiState={uiState}/>
        </Layout.Section>
      </Layout>
    </React.Fragment>
  );
});

export default withState(ResponseContainer, ResponseContainerState);
